export interface ExternalBrowserRecommendation {
  required: boolean;
  label: string;
  targetUrl: string;
  reason: string;
}

const BROWSER_CONFIRMED_PARAM = "browser";
const AUTO_START_PARAM = "autostart";

export function getExternalBrowserRecommendation(
  location: Location = window.location,
  userAgent: string = navigator.userAgent,
): ExternalBrowserRecommendation {
  const url = new URL(location.href);
  const isAndroid = /\bAndroid\b/i.test(userAgent);
  const browserConfirmed = url.searchParams.get(BROWSER_CONFIRMED_PARAM) === "1";

  if (!isAndroid || browserConfirmed) {
    return {
      required: false,
      label: "Iniciar experiência",
      targetUrl: url.toString(),
      reason: "system-browser-ready",
    };
  }

  url.searchParams.set(BROWSER_CONFIRMED_PARAM, "1");
  url.searchParams.set(AUTO_START_PARAM, "1");

  return {
    required: true,
    label: "Copiar link para Chrome",
    targetUrl: url.toString(),
    reason: "android-qr-camera-context",
  };
}

export async function copyExternalBrowserUrl(
  targetUrl: string,
  clipboard: Pick<Clipboard, "writeText"> | undefined = navigator.clipboard,
): Promise<boolean> {
  if (!clipboard?.writeText) {
    return false;
  }

  try {
    await clipboard.writeText(targetUrl);
    return true;
  } catch {
    return false;
  }
}
